module.exports = __webpack_public_path__ + "img/background_c4-2_mask.6793b381.jpg";